// Язык звонка фиксируется спекой на старте и внутри звонка не меняется;
// пустое значение — «как решит движок».
export const scenarioLangLabels: Record<string, string> = {
  ru: 'Русский',
  en: 'Английский',
  ar: 'Арабский',
}

export function scenarioLangLabel(lang: string): string {
  return scenarioLangLabels[lang] ?? 'Язык движка'
}

// Плотные места (пункт селекта) подписывают язык кодом, а не словом.
export function scenarioLangCode(lang: string): string {
  return scenarioLangLabels[lang] ? lang.toUpperCase() : '—'
}
